function checkCollection(url = "") {
  const isCollection = url.includes("/collections/");

  return Boolean(isCollection);
}

function getInfluencerFromURL() {
  console.log("Begin function getInfluencerFromURL()")
  const isCollection =
    window.theme?.pageType === "collection" ||
    window.location.href.includes("/collections/");
    console.log("collection page detected: ",window.location.href);

  // optional
  //   const isPreviousPageCollection = checkCollection(document.referrer);
  //
  //   if (!isCollection && !isPreviousPageCollection) {
  //     localStorage.removeItem('influencerName')
  //     return;
  //   }

  if (!isCollection) {
    console.log("collection page was not detected. Ignoring: ",window.location.href);
    return;
  }
  let collectionHandle = window.location.href;
  console.log("getting influencer handle for url: ",collectionHandle);
  collectionHandle = window.location.href.split("/collections/")[1];
  collectionHandle = collectionHandle.split("/")[0];
  storeInfluencerName(collectionHandle);
}

function storeInfluencerName(influencerName) {
  console.log("storing influencerName: ",influencerName);
  localStorage.setItem("influencerName", influencerName);
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/**
 * Create a hidden input element.
 * @param {string} propertyName - The name of the property for the input element.
 * @param {string} propertyValue - The value for the input element.
 * @returns {HTMLInputElement} - The created hidden input element.
 */
function createHiddenInput(propertyName, propertyValue) {
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = `properties[_${propertyName}]`;
  input.value = propertyValue;
  input.setAttribute("js-properties-input", propertyName.toLowerCase());

  return input;
}

/**
 * Append an input element to product forms.
 * @param {string} formSelector - The selector of the form to which the input element will be appended.
 */
function appendInputToProductForms(formSelector = '[action*="/cart/add"], [action*="/cart"]') {
  console.log("looking for form to add field.")
  const forms = document.querySelectorAll(formSelector);
  if(forms){
    console.log("Found Form: ",forms)
  }else{
    console.log("didn't find form")
  }
  const influencerName = localStorage.getItem("influencerName");
  console.log("Retrieved influencer name: ",influencerName)

  if (!forms.length || !influencerName) {
    console.log("Unable to find forms or influencer name")
    return;
  }

  forms.forEach((form) => {
    const influencerInput = form.querySelector(
      '[js-properties-input="influencer"]'
    );

    if (influencerInput) {
      console.log("Found influencer input: ",influencerInput)
      return;
    }

    const inputElement = createHiddenInput("Influencer", influencerName);
    console.log("creating hidden input element: ",inputElement);
    form.appendChild(inputElement);
  });
}

window.addEventListener("DOMContentLoaded", () => {
  getInfluencerFromURL();
  appendInputToProductForms('[action*="/cart/add"]');
  appendInputToProductForms(".pf-product-form");
  //   appendInputToProductForms('[action="/cart/add"]');
});
